import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-63d04cb2")

_pushScopeId("data-v-63d04cb2")
const _hoisted_1 = /*#__PURE__*/_createTextVNode("Interest")
const _hoisted_2 = {
  class: "fill df-col flex-1",
  style: {"padding":"20px 100px"}
}
const _hoisted_3 = {
  class: "my-16",
  style: {"line-height":"20px"}
}
const _hoisted_4 = { class: "py-16 bg-white df-col flex-1 mb-32" }
const _hoisted_5 = {
  class: "total px-16 py-12",
  style: {"background-color":"var(--color-background)"}
}
const _hoisted_6 = { class: "t-item df-between mb-8" }
const _hoisted_7 = /*#__PURE__*/_createTextVNode("Current Balance")
const _hoisted_8 = { class: "t-item df-between mb-8" }
const _hoisted_9 = /*#__PURE__*/_createTextVNode("Interest rate /YR")
const _hoisted_10 = { class: "t-item df-between mb-8" }
const _hoisted_11 = /*#__PURE__*/_createTextVNode("Estimated interest /YP")
const _hoisted_12 = { class: "t-item df-between" }
const _hoisted_13 = /*#__PURE__*/_createTextVNode("Interest credited")
const _hoisted_14 = { class: "i-table df-col my-16 flex-1 pb-32" }
const _hoisted_15 = { class: "i-t-head" }
const _hoisted_16 = {
  class: "df-between df-middle td-level c-tip f-sm mb-8",
  style: {"height":"24px"}
}
const _hoisted_17 = /*#__PURE__*/_createTextVNode("Date")
const _hoisted_18 = /*#__PURE__*/_createTextVNode("Balance")
const _hoisted_19 = /*#__PURE__*/_createTextVNode("Interest")
const _hoisted_20 = {
  class: "df-between df-middle td-level f-nm c-text",
  style: {"box-shadow":"inset 0px -1px 0px 0px #ECEFF4","height":"40px"}
}
const _hoisted_21 = { class: "df-middle" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_t = _resolveComponent("t")
  const _component_Money = _resolveComponent("Money")
  const _component_ColorText = _resolveComponent("ColorText")
  const _component_Tooltip = _resolveComponent("Tooltip")
  const _component_List = _resolveComponent("List")
  const _component_Holder = _resolveComponent("Holder")
  const _component_Scroller = _resolveComponent("Scroller")
  const _component_PageWithHeader = _resolveComponent("PageWithHeader")

  return (_openBlock(), _createBlock(_component_PageWithHeader, null, {
    title: _withId(() => [
      _createVNode(_component_t, { path: "interest_2" }, {
        default: _withId(() => [
          _hoisted_1
        ]),
        _: 1
      })
    ]),
    body: _withId(() => [
      _createVNode(_component_Scroller, { onBottomTouched: _ctx.loadMore }, {
        default: _withId(() => [
          _createVNode("div", _hoisted_2, [
            _createVNode("div", _hoisted_3, [
              _createVNode(_component_t, {
                as: "div",
                path: "interest_3",
                multiline: "",
                custom: ""
              }, {
                default: _withId(({td}) => [
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(td, (p, index) => {
                    return (_openBlock(), _createBlock("p", { key: index }, _toDisplayString(p), 1))
                  }), 128))
                ]),
                _: 1
              })
            ]),
            _createVNode("div", _hoisted_4, [
              _createVNode("div", _hoisted_5, [
                _createVNode("p", _hoisted_6, [
                  _createVNode(_component_t, {
                    path: "interest_4",
                    class: "c-title"
                  }, {
                    default: _withId(() => [
                      _hoisted_7
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_Money, {
                    class: "f-medium",
                    v: _ctx.prop('currentBalance', _ctx.data)
                  }, null, 8, ["v"])
                ]),
                _createVNode("p", _hoisted_8, [
                  _createVNode(_component_t, {
                    path: "interest_5",
                    class: "c-title"
                  }, {
                    default: _withId(() => [
                      _hoisted_9
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_ColorText, {
                    class: "f-nm f-medium",
                    value: _ctx.prop('interestRate', _ctx.data)
                  }, {
                    default: _withId(() => [
                      _createTextVNode(_toDisplayString(_ctx.prop('interestRate', _ctx.data) + '%'), 1)
                    ]),
                    _: 1
                  }, 8, ["value"])
                ]),
                _createVNode("p", _hoisted_10, [
                  _createVNode(_component_t, {
                    path: "interest_6",
                    class: "c-title"
                  }, {
                    default: _withId(() => [
                      _hoisted_11
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_Money, {
                    class: "f-medium f-nm",
                    v: _ctx.prop('interest', _ctx.data)
                  }, {
                    default: _withId(({ text, origin }) => [
                      _createVNode(_component_ColorText, {
                        value: _ctx.prop('interest', _ctx.data)
                      }, {
                        default: _withId(() => [
                          _createTextVNode(_toDisplayString(text), 1)
                        ]),
                        _: 2
                      }, 1032, ["value"])
                    ]),
                    _: 1
                  }, 8, ["v"])
                ]),
                _createVNode("p", _hoisted_12, [
                  _createVNode(_component_t, {
                    path: "interest_7",
                    class: "c-title"
                  }, {
                    default: _withId(() => [
                      _hoisted_13
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_Money, {
                    class: "f-medium f-nm",
                    v: _ctx.prop('interestCredit', _ctx.data)
                  }, {
                    default: _withId(({ text, origin }) => [
                      _createVNode(_component_ColorText, {
                        value: _ctx.prop('interestCredit', _ctx.data)
                      }, {
                        default: _withId(() => [
                          _createTextVNode(_toDisplayString(text), 1)
                        ]),
                        _: 2
                      }, 1032, ["value"])
                    ]),
                    _: 1
                  }, 8, ["v"])
                ])
              ]),
              _createVNode("div", _hoisted_14, [
                _createVNode("div", _hoisted_15, [
                  _createVNode("p", _hoisted_16, [
                    _createVNode(_component_t, { path: "interest_8" }, {
                      default: _withId(() => [
                        _hoisted_17
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_t, { path: "interest_9" }, {
                      default: _withId(() => [
                        _hoisted_18
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_t, { path: "interest_10" }, {
                      default: _withId(() => [
                        _hoisted_19
                      ]),
                      _: 1
                    })
                  ])
                ]),
                _createVNode(_component_Holder, {
                  content: _ctx.loaded,
                  "skeleton-repeat": 1,
                  "holder-class": "px-16"
                }, {
                  default: _withId(() => [
                    _createVNode(_component_List, {
                      "list-data": _ctx.loaded,
                      "pull-refresh": "",
                      onRefresh: _ctx.refresh
                    }, {
                      default: _withId(({ item }) => [
                        _createVNode("p", _hoisted_20, [
                          _createVNode("span", null, _toDisplayString(item.issue), 1),
                          _createVNode(_component_Money, {
                            v: item.balance
                          }, null, 8, ["v"]),
                          _createVNode("span", _hoisted_21, [
                            _createVNode(_component_Money, {
                              class: "f-medium f-nm",
                              v: item.interest
                            }, {
                              default: _withId(({ text, origin }) => [
                                _createVNode(_component_ColorText, {
                                  value: item.interest
                                }, {
                                  default: _withId(() => [
                                    _createTextVNode(_toDisplayString(text), 1)
                                  ]),
                                  _: 2
                                }, 1032, ["value"])
                              ]),
                              _: 2
                            }, 1032, ["v"]),
                            (item.cause)
                              ? (_openBlock(), _createBlock(_component_Tooltip, { key: 0 }, {
                                  default: _withId(() => [
                                    _createVNode("p", null, _toDisplayString(item.cause), 1)
                                  ]),
                                  _: 2
                                }, 1024))
                              : _createCommentVNode("", true)
                          ])
                        ])
                      ]),
                      _: 1
                    }, 8, ["list-data", "onRefresh"])
                  ]),
                  _: 1
                }, 8, ["content"])
              ])
            ])
          ])
        ]),
        _: 1
      }, 8, ["onBottomTouched"])
    ]),
    _: 1
  }))
})